import {
  AlignItems,
  Box,
  Color,
  H3,
  JustifyContent,
  P,
  Separator,
  TypePreset,
} from "@gocardless/flux-react";
import { Trans } from "@lingui/macro";
import Image from "next/legacy/image";

import SignUpLogos from "/src/assets/png/signup-logos-gb.png";
import PaymentsCollectedOnTime from "/src/assets/png/payments-collected-on-time.png";

export const SignUpMarketing = () => (
  <Box
    layout="flex"
    flexDirection="column"
    justifyContent={JustifyContent.Center}
    alignItems={AlignItems.Center}
    width="389px"
    minHeight="100dvh"
    css={{
      margin: "0px auto",
    }}
  >
    <Box width="389px" spaceBelow={1}>
      <Image
        src={PaymentsCollectedOnTime}
        width={389}
        height={223}
        alt="Payments collected on time"
      />
    </Box>
    <H3
      color={Color.Greystone_50}
      spaceBelow={1}
      size={13}
      preset={TypePreset.Display_01}
      textTransform="uppercase"
    >
      <Trans id="sign-up.get-started-marketing.heading">
        Your payments collected on time
      </Trans>
    </H3>
    <P color={Color.Greystone_50} preset={TypePreset.Body_02}>
      <Trans id="sign-up.get-started-marketing.text">
        &quot;Collecting payments could not get any easier&quot; — G2 Review
      </Trans>
    </P>
    <Box width="100%" spaceBelow={2} spaceAbove={2}>
      {""}
      <Separator color={Color.Greystone_50} />
    </Box>
    <Box
      layout="flex"
      flexDirection="row"
      width="389px"
      justifyContent={JustifyContent.SpaceBetween}
    >
      <Image src={SignUpLogos} alt="" width={389} height={31.63} />
    </Box>
  </Box>
);
